import React from 'react';

/** Badge promotion tarifaire — liste publique */
export default function PromoEventBadge({ className = '', discountPercent = null }) {
    const label =
        discountPercent && discountPercent > 0 ? `Promo −${discountPercent}%` : 'Promo';

    return (
        <span
            className={`relative isolate inline-flex items-center gap-1 overflow-hidden rounded-full border border-rose-200/90 bg-gradient-to-r from-rose-700 via-rose-500 to-orange-400 px-2.5 py-0.5 text-[10px] font-extrabold uppercase tracking-[0.12em] text-white shadow-[0_2px_12px_rgba(190,18,60,0.4),inset_0_1px_0_rgba(255,255,255,0.35)] ring-1 ring-white/25 ${className}`}
            aria-label="Événement en promotion"
            style={{ animation: 'promoBadgeAlert 1.1s ease-in-out infinite' }}
        >
            <svg
                className="relative z-[1] h-3 w-3 shrink-0 text-rose-50 drop-shadow-[0_1px_1px_rgba(0,0,0,0.35)]"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden
            >
                <path d="M21.41 11.58l-9-9A2 2 0 0011 2H4a2 2 0 00-2 2v7a2 2 0 00.59 1.41l9 9a2 2 0 002.82 0l7-7a2 2 0 000-2.83zM6.5 8A1.5 1.5 0 118 6.5 1.5 1.5 0 016.5 8z" />
            </svg>
            <span className="relative z-[1]">{label}</span>
            <style>{`
                @keyframes promoBadgeAlert {
                    0%, 100% { opacity: 1; filter: brightness(1); transform: scale(1); }
                    45% { opacity: 0.35; filter: brightness(1.35); transform: scale(1.04); }
                    55% { opacity: 1; filter: brightness(1.15); transform: scale(1.02); }
                }
                @media (prefers-reduced-motion: reduce) {
                    span[aria-label="Événement en promotion"] { animation: none !important; }
                }
            `}</style>
        </span>
    );
}

/** Infos promo dérivées du pricing API publique (has_promo calculé côté serveur). */
export function getEventPromoDisplay(pricing = []) {
    if (!Array.isArray(pricing) || pricing.length === 0) {
        return { hasPromo: false, maxDiscountPercent: null };
    }

    const promoTickets = pricing.filter((p) => {
        if (!p?.has_promo || p.original_price == null) return false;
        return Number(p.original_price) > Number(p.price);
    });

    if (promoTickets.length === 0) {
        return { hasPromo: false, maxDiscountPercent: null };
    }

    let maxDiscountPercent = null;
    promoTickets.forEach((p) => {
        const orig = Number(p.original_price);
        const price = Number(p.price);
        const pct = Math.round(((orig - price) / orig) * 100);
        if (maxDiscountPercent === null || pct > maxDiscountPercent) {
            maxDiscountPercent = pct;
        }
    });

    return { hasPromo: true, maxDiscountPercent };
}
